export default {
  "content": "<path fill=\"#fff\" d=\"M0 14l1.4-1.425 2.6 2.6V0h2v15.175l2.6-2.6L10 14l-5 5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "19",
    "fill": "none"
  }
};